import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

export const transformStatsErrorResponse = (
  response: FetchBaseQueryError,
): FetchBaseQueryError & { message?: string } => {
  if (response.status === 'FETCH_ERROR') {
    return { ...response, message: 'Analytics backend is not reachable from your network.' }
  }
  return response
}
